import React from 'react'
import PropTypes from 'prop-types'
import Progress from './'

export default class ProgressWithContext extends React.Component {
  static contextTypes = {
    containerWidth: PropTypes.number
  }

  render() {
    const {containerWidth} = this.context

    return (
      <Progress
        width={containerWidth}
        {...this.props}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/Progress/ProgressWithContext.js